import { render, staticRenderFns } from "./FixedBearingsTransverseTraction.vue?vue&type=template&id=680927f6&scoped=true"
import script from "./FixedBearingsTransverseTraction.vue?vue&type=script&lang=js"
export * from "./FixedBearingsTransverseTraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680927f6",
  null
  
)

export default component.exports